import { render, staticRenderFns } from "./VarientTooltip.vue?vue&type=template&id=2842116f"
import script from "./VarientTooltip.vue?vue&type=script&lang=js"
export * from "./VarientTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports